import PropTypes from 'prop-types';
import React, { useEffect, useLayoutEffect } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { noun } from 'plural-ru';

import Modal from '@mos-cat/modal';
import TextArea from '@mos-cat/text-area';

import ExamInformation from '../../components/ExamInformation/ExamInformation';
import ModalTable from '../../components/Table/ModalTable';
import Button from '../../components/Button/Button';

import { EMOJI_REGEXP } from '../../constants/regexp';

import { gradesTableType } from '../../propTypes/gradesTableType';

import submitAppeal from '../../store/appealDataRequest/actions';
import { showApproveModal } from '../../store/step/actions';
import { updateAppealData } from '../../store/examData/actions';
import { sendCMAAppealBusinessError } from '../../helpers/CMAStats';

import structuredSelector from './structuredSelector';

import './Confirmation.pcss';

export const pluralizeNumber = (number) =>
  noun(number, 'балл', 'балла', 'баллов');

const Confirmation = ({
  exam,
  onSubmit,
  onClose,
  appealGrades,
  loading,
  onUpdateAppealData,
  showConfirmation,
  stepConfirmation,
}) => {
  const bodyPositionClass = 'body_position-fixed';

  const closeModal = () => {
    const scrollY = document.body.style.top;

    document.body.classList.remove(bodyPositionClass);
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };

  const handleClose = () => {
    closeModal();
    onClose(true);
  };

  const handleSubmit = () => {
    onSubmit();
    closeModal();
  };

  useEffect(() => {
    if (stepConfirmation && !showConfirmation) {
      handleClose();
      sendCMAAppealBusinessError({ stage: 'final' });
    }
  }, [showConfirmation, stepConfirmation]);

  useLayoutEffect(() => {
    if (showConfirmation) {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.classList.add(bodyPositionClass);
    }
  }, [showConfirmation]);

  return exam ? (
    <Modal visible={showConfirmation} onCancel={handleClose}>
      <h3 className="Modal__title">{exam.subject_name}</h3>
      <section className="Confirmation">
        <p className="Confirmation__text">
          Проверьте номера отмеченных заданий, с оцениванием которых Вы не
          согласны, и внесенные комментарии
        </p>
        <ExamInformation exam={exam} />
        {exam.type_is_gve ? (
          <>
            <p className="Confirmation__text Confirmation__text__gve">
              {exam.subject_name} - {exam.score} {pluralizeNumber(exam.score)}
            </p>
            <TextArea
              className="Table__answers-comment-text-field"
              label="Ваш комментарий"
              onChange={(event) =>
                onUpdateAppealData({
                  comment: event.currentTarget.value.replace(EMOJI_REGEXP, ''),
                  checked: true,
                  changedTask: {
                    task_number: 'c_1',
                    task_name: exam.subject_name,
                    test_score: exam.score,
                    detailed: false,
                    primary_score: '5',
                  },
                })
              }
              value={
                exam.grades_table.length ? exam.grades_table[0].comment : ''
              }
              error={
                exam.grades_table.length ? exam.grades_table[0].invalid : false
              }
              maxLength={1000}
            />
          </>
        ) : (
          <ModalTable
            key={exam.type + exam.date}
            className="Correction__table"
            data={appealGrades}
            gve={exam.type_is_gve}
            tablesHtml={exam.grades_table_raw}
          />
        )}
        <div className="Confirmation__actions">
          <Button
            primary
            progress={loading || undefined}
            onClick={handleSubmit}
          >
            Подать апелляцию
          </Button>
          <Button onClick={handleClose}>Отменить</Button>
        </div>
      </section>
    </Modal>
  ) : null;
};

Confirmation.propTypes = {
  exam: PropTypes.shape({
    subject_name: PropTypes.string,
    type: PropTypes.string,
    date: PropTypes.string,
  }).isRequired,
  appealGrades: gradesTableType.isRequired,
  showConfirmation: PropTypes.bool.isRequired,
  stepConfirmation: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUpdateAppealData: PropTypes.func.isRequired,
};

export default connect(structuredSelector, (dispatch) =>
  bindActionCreators(
    {
      onClose: showApproveModal,
      onSubmit: submitAppeal,
      onUpdateAppealData: updateAppealData,
    },
    dispatch,
  ),
)(Confirmation);
